import { useDispatch } from "react-redux";
import { useCallback, useState } from "react";
import { get, isEmpty, debounce, omit } from "lodash";
import { loadCustomerAutoFillSuggestions } from "../services/helpers";
import { setCustomerEditorInput, setLoadingCustomerForEdit } from "../actions";
import { buildTabcId } from "utilities/dist/customer/helpers";

export const useCustomerAutoFillFinder = () => {
    const dispatch = useDispatch();
    const [query, setQuery] = useState("");
    const [error, setError] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [isLoading, setLoading] = useState(false);

    const loadSuggestions = useCallback(query => {
        setLoading(true);

        loadCustomerAutoFillSuggestions(query)
            .then(res => {
                setCustomers(res.data);
                setLoading(false);
                setError(null);
            })
            .catch(err => {
                setLoading(false);
                const message = get(err, "response.data.message", null) || err.message;
                setError(message);
            });
    }, []);
    const debouncedLoadSuggestion = useCallback(debounce(loadSuggestions, 300), []);

    const handleSearchChange = (e, { searchQuery }) => {
        setQuery(searchQuery);

        if (searchQuery.length > 2) {
            debouncedLoadSuggestion(searchQuery);
        }
    };

    const handleChange = (e, { value }) => {
        const customer = customers.find(cust => cust.establishment_id === value);

        if (!isEmpty(customer)) {
            const editorInputs = omit(customer, ["permitCodes"]);
            const { aims_id, aims_license_type, permit_code, establishment_id } =
                customer.permitCodes?.[0] || {};
            // permit_codes entries won't have a tabc_id column so tabcFromAims will only have a value
            // if there are aims data in which case, we want to use the aims data as tabc id
            const tabcFromAims = buildTabcId({ aims_id, aims_license_type });
            editorInputs.tabc_id = tabcFromAims || permit_code;
            editorInputs.aims_id = `${aims_id}`;
            editorInputs.aims_license_type = aims_license_type;
            editorInputs.ydk_est_id = establishment_id;
            // a bit hacky but it makes sure to trigger a rerender of the formik form with new data
            dispatch(setLoadingCustomerForEdit(true));
            dispatch(setCustomerEditorInput(editorInputs));
            setTimeout(dispatch, 100, setLoadingCustomerForEdit(false));
        }
    };

    return {
        error,
        query,
        isLoading,
        customers,
        handleChange,
        handleSearchChange,
    };
};
